module.exports = __webpack_public_path__ + "img/master-photo.9447a853.png";